// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","logo":"Footer_logo__+JiYo","link":"Footer_link__3Ie8d"};